<template>
<div class="bg-white">
    <ThankyouHeader />

    <div class="gr py-10">
        <div class="flex flex-col md:flex-row text-center text-sm -mx-4">
            <ThankyouFeaturesColumn v-for="(featureColumn, i) in featureColumns" :featureColumn="featureColumn" :key="i" />
        </div>
    </div>
</div>
</template>

<script>
    import ThankyouHeader from './components/ThankyouHeader';
    import ThankyouFeaturesColumn from './components/ThankyouFeaturesColumn';
    
    export default {
        components: {
            ThankyouHeader,
            ThankyouFeaturesColumn
        },
        data: () => ({
            featureColumns: [
                {
                    title: 'Install',
                    features: [
                        {
                            icon: 'integrations-big',
                            title: 'Integrations',
                            description: 'Download and import every asset you need right inside of your Adobe applications.',
                            button: {
                                link: '/integrations/adobe/',
                                label: 'Install integrations'
                            }
                        }, {
                            icon: 'plugins-big',
                            title: 'Exclusive Plugins',
                            description: 'Drag & drop unique effects and transitions with these exclusive plugins for Premiere Pro.',
                            button: {
                                link: '/plugins/',
                                label: 'Install plugins'
                            }
                        }
                    ] 
                },
                {
                    title: 'Download',
                    features: [
                        {
                            icon: 'marketplace-big',
                            title: 'Marketplace',
                            description: 'Browse and download everything you need, from video templates to music, photos and more.',
                            button: {
                                link: '/browse/',
                                label: 'Explore marketplace'
                            }
                        }, {
                            icon: 'requests-big',
                            title: 'Requests',
                            description: 'Cant find exactly what you need? Make a request for a specific asset.',
                            button: {
                                link: '/requests/',
                                label: 'Browse requests'
                            }
                        }
                    ] 
                },
            ]
        }),

        metaInfo: () => ({
            bodyAttrs: { class: 'with--nav-background thankyou-page'},
            title: 'Thank you - Sign up | Motion Array',
            link: [ {  rel:'stylesheet', href: '/assets/site/css/thank-you.css?v=2' } ]
        })
    }
</script>